"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Logger with access to browser's debugging console.
 *
 * @hideConstructor
 */
// TODO: add levels of logging: INFO and ERROR.
// or allow to disable logging for prod builds
var ConsoleLog = /*#__PURE__*/function () {
  function ConsoleLog() {
    _classCallCheck(this, ConsoleLog);
  }

  _createClass(ConsoleLog, null, [{
    key: "getDefaultLogger",
    value: function getDefaultLogger() {
      return console;
    }
  }, {
    key: "getErrorLogger",
    value: function getErrorLogger() {
      return console;
    }
  }, {
    key: "debug",
    value: function debug() {
      var log = ConsoleLog.getDefaultLogger(); // Define DEBUG at buildtime to suppress console output
      // eslint-disable-next-line no-undef

      if (typeof DEBUG !== 'undefined' && DEBUG) {
        log.debug.apply(log, arguments);
      }
    }
  }, {
    key: "info",
    value: function info() {
      var log = ConsoleLog.getDefaultLogger();
      log.info.apply(log, arguments);
    }
  }, {
    key: "warn",
    value: function warn() {
      var log = ConsoleLog.getDefaultLogger();
      log.warn.apply(log, arguments);
    }
  }, {
    key: "error",
    value: function error() {
      var log = ConsoleLog.getErrorLogger();
      log.error.apply(log, arguments);
    }
  }]);

  return ConsoleLog;
}();

module.exports = ConsoleLog;